import { Box } from "@mui/material";
import './loader.css';

const Loader = ({ sx, loaderWidth = "30px" }) => {
  return (
    <Box sx={{...sx, display: "flex", justifyContent: "center", alignItems: "center"}} className="loaderContainer">
      <div style={{ width: loaderWidth }} className="loader"></div>
    </Box>
  )
}

export default Loader;